import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {Therapeut} from '../therapeut';
import {ZahValidators} from '../../core/form/validators';

@Component({
    selector: 'zah-upsert-therapeut',
    templateUrl: './upsert-therapeut.component.html',
    styleUrls: ['./upsert-therapeut.component.scss'],
    standalone: false
})
export class UpsertTherapeutComponent implements OnInit {

  @Input()
  therapeut?: Therapeut;
  @Input()
  okLabel: string;
  @Output()
  cancelClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  okClicked: EventEmitter<Therapeut> = new EventEmitter<Therapeut>();

  upsertTherapeutForm: FormGroup;

  ngOnInit(): void {
    this.upsertTherapeutForm = new FormGroup({
      voornaam: new FormControl(this.therapeut?.getVoornaam(), ZahValidators.notBlank),
      achternaam: new FormControl(this.therapeut?.getAchternaam(), ZahValidators.notBlank),
      personeelsnummer: new FormControl(
        {value: this.therapeut?.getPersoneelsnummer(), disabled: !!this.therapeut},
        ZahValidators.notBlank),
      email: new FormControl(
        {value: this.therapeut?.getEmail(), disabled: !!this.therapeut},
        [ZahValidators.notBlank, Validators.email]),
    });
  }

  onCancelClicked(): void {
    this.cancelClicked.emit();
  }

  onOkClicked(): void {
    this.okClicked.emit(new Therapeut(
      this.therapeut?.getId(),
      this.voornaam.value,
      this.achternaam.value,
      this.personeelsnummer.value,
      this.email.value,
      )
    );
  }

  get voornaam(): AbstractControl {
    return this.upsertTherapeutForm.controls.voornaam;
  }

  get achternaam(): AbstractControl {
    return this.upsertTherapeutForm.controls.achternaam;
  }

  get personeelsnummer(): AbstractControl {
    return this.upsertTherapeutForm.controls.personeelsnummer;
  }

  get email(): AbstractControl {
    return this.upsertTherapeutForm.controls.email;
  }
}
